export default {
	namespaced: true,
	state: {
		settings: {
			colorMode: 'darkMode',
			audio: true,
		},
		menu: {
			active: false,
		},
		restart: false,
	},
	mutations: {
		setDarkMode(state) {
			state.settings.colorMode = 'darkMode'
		},
		setLightMode(state) {
			state.settings.colorMode = 'lightMode'
		},
		setMode(state, value) {
			state.settings.colorMode = value
		},
		toggleColorMode(state) {
			// eslint-disable-next-line prettier/prettier
			if (state.settings.colorMode == 'lightMode')
				state.settings.colorMode = 'darkMode'
			else state.settings.colorMode = 'lightMode'
		},
		setMenuActive(state, value) {
			state.menu.active = value
		},
		setRestart(state, bool) {
			state.restart = bool
		},
		setAudio(state, bool) {
			state.settings.audio = bool
		},
	},
	actions: {
		setDarkMode({ commit }) {
			commit('setDarkmode')
		},
		toggleAudio({ commit, state }) {
			commit('setAudio', !state.settings.audio)
		},
		setLightMode({ commit }) {
			commit('setLightMode')
		},
		toggleColorMode({ commit }) {
			commit('toggleColorMode')
		},
		setMode({ commit }, value) {
			commit('setMode', value)
		},
		setMenuActive({ commit }, bool) {
			commit('setMenuActive', bool)
		},
		toggleMenuActive({ commit, state }) {
			commit('setMenuActive', !state.menu.active)
		},
		setRestart({ commit, state }, bool) {
			if (!state.restart) commit('setRestart', bool)
		},
	},
}
